<template>
  <div class="d-flex">
    <MainBarMenuV2 />
    <div class="layout-content container-fluid">
      <HeadingUser />
      <div class="col-12 my-5">
        <Breadcrumb :items="breadcrumb" />
        <div class="d-flex justify-content-between align-items-center">
          <Typography
            :text="`Anexos y pruebas - ${
              typeDocument?.name ? typeDocument?.name : '...'
            }`"
            variant="h1"
            class="m-0"
          />
        </div>
        <Typography
          :text="`Sube los archivos de ${
            typeDocument?.name ? typeDocument?.name : '...'
          } en un solo lugar.`"
          variant="body"
          class="m-0 pt-2 mt-2"
        />
        <div class="my-4">
          <div>
            <button
              class="button-primary"
              style="color: white !important"
              @click.prevent="showModalDownloadFile"
            >
              Cargar documentos
            </button>
          </div>
          <b-overlay :show="loading" rounded="sm">
            <template #overlay>
              <OverlayButton clase="overlay-md"> </OverlayButton>
            </template>
            <div v-if="records.length > 0">
              <div class="d-flex flex-wrap gap-2 mt-5">
                <CardDocument
                  v-for="(item, index) in records"
                  :key="index"
                  :item="item"
                  @deleteDocument="deleteDocument"
                />
              </div>
              <!-- <div class="overflow-auto my-4">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  aria-controls="my-table"
                  align="center"
                ></b-pagination>
              </div> -->
            </div>
            <div v-else class="my-4">
              <p class="text-center py-5">No se encontraron documentos</p>
            </div>
          </b-overlay>
        </div>
        <div class="my-5">
          <div class="d-flex justify-content-between align-items-center">
            <Typography
              text="Historial de modificaciones"
              variant="h1"
              class="m-0"
            />
            <button
              class="button-primary"
              style="color: white !important"
              @click.prevent="toogleHistory()"
            >
              {{ isHistory ? "Ocultar" : "Ver" }} historial
            </button>
          </div>
          <div class="my-4" v-if="isHistory">
            <TableHistory :records="histories" :isLoaging="isLoadingHistory" />
          </div>
        </div>
      </div>
    </div>
    <ModalDocument
      :processId="processId"
      :documentType="documentType"
      @onSuccess="onSuccessDocument"
      @onError="onError"
    />
    <ModalSuccess :messageModal="messageModal" />
    <ModalError :messageModal="messageModal" />
    <ModalConfirm
      :item="record"
      @onSuccess="onSuccessDocument"
      @onError="onError"
    />
  </div>
</template>

<script>
import processSevices from "@/services/legal/service.js";
//Components
import MainBarMenuV2 from "@/components/layouts/MainBarMenuV2.vue";
import HeadingUser from "@/components/user/HeadingUser.vue";
import Typography from "@/components/general/Typography";
import Breadcrumb from "@/components/general/Breadcrumb";
import OverlayButton from "@/components/core/overlay/overlay-button.vue";
import CardDocument from "./components/CardDocument.vue";
import ModalDocument from "./components/modal/ModalDocument.vue";
import ModalSuccess from "./components/modal/ModalSuccess.vue";
import ModalError from "./components/modal/ModalError.vue";
import ModalConfirm from "./components/modal/ModalConfirm.vue";
import TableHistory from "./components/TableHistory.vue";

export default {
  components: {
    MainBarMenuV2,
    HeadingUser,
    Typography,
    Breadcrumb,
    OverlayButton,
    CardDocument,
    ModalDocument,
    ModalSuccess,
    ModalError,
    ModalConfirm,
    TableHistory,
  },
  data() {
    const me = this;
    return {
      breadcrumb: [
        {
          name: "Repositorio de documentación",
          active: false,
          link: `/legal/documentation/${me.$route.params.id}`,
        },
        { name: "Anexos y pruebas", active: true, link: "" },
      ],
      loading: true,
      isLoadingHistory: true,
      isHistory: false,
      records: [],
      histories: [],
      typeDocument: null,
      record: null,
      messageModal: "",
      perPage: 5,
      currentPage: 1,
      totalRows: 0,
    };
  },
  computed: {
    processId() {
      return parseInt(this.$route.params.id || "0");
    },
    documentType() {
      return this.$route.params.type || "0";
    },
  },
  methods: {
    showModalDownloadFile() {
      this.$bvModal.show("modal-download-file");
    },
    async loadProcessFiles() {
      const me = this;
      me.loading = true;
      me.records = [];
      try {
        const { data } = await processSevices.getListProcessFiles(
          me.processId,
          {
            type: me.documentType,
          }
        );
        me.records = data?.data;
        me.totalRows = data?.total;
        me.perPage = data?.per_page;
      } catch (error) {
        console.log(error);
      } finally {
        me.loading = false;
      }
    },
    async listTypeDocuments() {
      const me = this;
      try {
        const { data } = await processSevices.getListTypeFiles(me.processId);
        me.typeDocument = data?.find((x) => x.type == me.documentType);
      } catch (error) {
        console.log(error);
      }
    },
    async loadHistory() {
      const me = this;
      me.isLoadingHistory = true;
      try {
        const { data } = await processSevices.getHistoryFile(
          me.processId,
          me.documentType
        );
        me.histories = data?.data;
      } catch (error) {
        console.log(error);
      } finally {
        me.isLoadingHistory = false;
      }
    },
    onSuccessDocument(message) {
      const me = this;
      me.$bvModal.show("modal-success");
      me.messageModal = message;
      me.loadProcessFiles();
      me.loadHistory();
    },
    onError(messgae) {
      const me = this;
      me.messageModal = messgae;
      me.$bvModal.show("modal-fail");
    },
    deleteDocument(item) {
      const me = this;
      me.record = item;
      me.$bvModal.show("modal-confirm-delete");
    },
    toogleHistory() {
      const me = this;
      me.isHistory = !me.isHistory;
      if (me.isHistory) {
        me.loadHistory();
      }
    },
    changePage(page = 1) {
      console.log(page);
    },
  },
  async mounted() {
    const me = this;
    await me.listTypeDocuments();
    me.loadProcessFiles();
  },
};
</script>

<style lang="css" scoped>
.gap-2 {
  gap: 1.5rem;
}
</style>
